export default __webpack_public_path__ + "static/media/PHK市中心_white.2c3c5b06.jpg";